import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatDividerModule } from '@angular/material/divider';
import { MatSelectModule } from '@angular/material/select';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatMomentDateModule } from "@angular/material-moment-adapter";
import { MatNativeDateModule } from '@angular/material/core';
import { MatStepperModule } from '@angular/material/stepper';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatListModule } from '@angular/material/list';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabsModule } from '@angular/material/tabs';
import { MatSortModule } from '@angular/material/sort';
import { MatCardModule } from '@angular/material/card';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { SharedModule } from '../shared/shared.module';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxMaskModule } from 'ngx-mask';
import {InputSwitchModule} from 'primeng/inputswitch';
import { UserModule } from '../user/user.module';
import { RolesModule } from '../roles/roles.module';
import { MatIconModule } from '@angular/material/icon';
import { LcaListComponent } from './lca-list/lca-list.component';
import { AddLcaNewComponent } from './add-lca-new/add-lca-new.component';
import { LCARoutingModule } from './lca-routing.module';
import { WithdrawLcaComponent } from './withdraw-lca/withdraw-lca.component';
import { ManageLcaComponent } from './manage-lca/manage-lca.component';
import { ViewLcaComponent } from './view-lca/view-lca.component';
import { EmployerInformationLcaComponent } from './employer-information-lca/employer-information-lca.component';
import { EmployerContactInformationComponent } from './employer-contact-information/employer-contact-information.component';
import { EmployerLabourConditionComponent } from './employer-labour-condition/employer-labour-condition.component';
import { PublicDiscloserInfoComponent } from './public-discloser-info/public-discloser-info.component';
import { NoticeOfObligationsComponent } from './notice-of-obligations/notice-of-obligations.component';
import { LcaPreparerComponent } from './lca-preparer/lca-preparer.component';
import { AttorneyAgentInformationComponent } from './attorney-agent-information/attorney-agent-information.component';
import { LcaDetailsComponent } from './lca-details/lca-details.component';
import { EmployerLabourConditionStatementComponent } from './employer-labour-condition-statement/employer-labour-condition-statement.component';
import { EmploymentWageInformationComponent } from './employment-wage-information/employment-wage-information.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { SaveAsDraftModule } from 'save-as-draft';
import { PostLcaComponent } from './post-lca/post-lca.component';
import { InternalJobPostingComponent } from './internal-job-posting/internal-job-posting.component';
import { ActionAlertModalComponent } from './action-alert-modal/action-alert-modal.component';
import { ViewPostedLcaComponent } from './view-posted-lca/view-posted-lca.component';
import { LcaDetailsViewModeComponent } from './lca-details-view-mode/lca-details-view-mode.component';
import { UpdateDecisionComponent } from './update-decision/update-decision.component';

@NgModule({
  declarations: [
    LcaListComponent,
    AddLcaNewComponent,
    WithdrawLcaComponent,
    ManageLcaComponent,
    ViewLcaComponent,
    EmployerInformationLcaComponent,
    EmployerContactInformationComponent,
    AttorneyAgentInformationComponent,
    EmploymentWageInformationComponent,
    EmployerLabourConditionComponent,
    PublicDiscloserInfoComponent,
    NoticeOfObligationsComponent,
    LcaPreparerComponent,
    AttorneyAgentInformationComponent,
    LcaDetailsComponent,
    EmployerLabourConditionStatementComponent,
    PostLcaComponent,
    InternalJobPostingComponent,
    ActionAlertModalComponent,
    ViewPostedLcaComponent,
    LcaDetailsViewModeComponent,
    UpdateDecisionComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    LCARoutingModule,
    MatPaginatorModule,
    MatTableModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatCheckboxModule,
    MatDividerModule,
    MatSelectModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatNativeDateModule,
    MatTooltipModule,
    MatSortModule,
    MatCardModule,
    MatStepperModule,
    MatExpansionModule,
    MatListModule,
    MatSlideToggleModule,
    ReactiveFormsModule,
    MatTabsModule,
    NgxMatSelectSearchModule,
    FormsModule,
    UserModule,
    ConfirmDialogModule,
    RolesModule,
    NgxMaskModule.forRoot({
      validation: true,
    }),
    MatIconModule,
    MatRadioModule,
    InputSwitchModule,
    SaveAsDraftModule
  ],
  providers: [],
  exports:[ManageLcaComponent]
})
export class LCAModule { }
